import { Chat, ChatId } from '@common-types/chat'
import VirtualizationCache from '@services/virtualization-cache'

export default new VirtualizationCache<ChatId, Chat>()
